import { PropagateLoader } from "react-spinners";

// const maindiv = {
//   position: "absolute",
//   display: "flex",
//   justifyContent: "center",
//   alignItems: "flex-start",
//   // paddingTop: "150px",
//   background: "#0d0415c9",
//   height: "2840px",
//   width: "100%",
//   zIndex: "9999",
// };

// const override = {
//   display: "block",
//   margin: "0 auto",
//   //   borderColor: "red",
//   //   display: "flex",
//   //   justifyContent: "center",
//   //   alignItems: "center",
//   //   position: "absolute",
//   //   top: "200px",
//   //   bottom: 0,
//   //   left: 0,
//   //   right: 0,
//   //   backgroundColor: "rgba(0,0,0,0.5)",
// };

const maindiv = {
  position: "absolute",
  display: "flex",
  justifyContent: "center",
  alignItems: "flex-start",
  background: "#0d0415c9",
  height: "2850px",
  width: "100%",
  zIndex: "9999",
};

const override = {
  display: "block",
  margin: "0 auto",
  borderColor: "red",
};

const Loader = ({ loading }) => {
  return (
    <div
      className={`${loading ? "pt-100" : ""}`}
      style={loading ? maindiv : {}}
    >
      <PropagateLoader
        color="#BC1DC3"
        size={loading ? 50 : 0}
        cssOverride={{ ...override }}
      />
    </div>
  );
};
export default Loader;
